import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, IconButton } from '@mui/material';
import { Upload } from '@mui/icons-material';

const NoteDialog = ({
  open,
  isEditing,
  newNote,
  setNewNote,
  selectedNote,
  setIsEditingNote,
  setSelectedNote,
  handleSaveNote,
  handleFileUpload,
  fileInputRef,
  setOpenNoteDialog,
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpenNoteDialog(false);
        setIsEditingNote(false);
        setSelectedNote(null);
      }}
    >
      <DialogTitle>{isEditing ? 'Edit Lecture Note' : 'Add Lecture Note'}</DialogTitle>
      <DialogContent>
        <TextField
          label="Title"
          fullWidth
          value={newNote.title || ''}
          onChange={(e) => setNewNote({ ...newNote, title: e.target.value })}
          margin="normal"
        />
        <TextField
          label="Content"
          fullWidth
          multiline
          rows={4}
          value={newNote.note_content || ''}
          onChange={(e) => setNewNote({ ...newNote, note_content: e.target.value })}
          margin="normal"
        />
        <TextField
          label="Link"
          fullWidth
          value={newNote.link || ''}
          onChange={(e) => setNewNote({ ...newNote, link: e.target.value })}
          margin="normal"
        />
        <Button
          variant="contained"
          startIcon={<Upload />}
          onClick={() => fileInputRef.current.click()}
        >
          Upload File
        </Button>
        <input
          type="file"
          hidden
          ref={fileInputRef}
          onChange={(e) => handleFileUpload(e, 'note')}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpenNoteDialog(false);
            setIsEditingNote(false);
            setSelectedNote(null);
          }}
        >
          Cancel
        </Button>
        <Button onClick={handleSaveNote} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoteDialog;